import { define } from '@components/Component.js'
import { h } from '@core/dom.js'
import { brandIcons, uiIcons } from '@/shared/brandIcons.js'
import { waLink } from '@/shared/utils/whatsapp.js'
import { youtubeEmbed } from '@/shared/youtube.js'

const SOCIAL_ICONS = {
    instagram: { icon: brandIcons.instagram, label: 'Instagram' },
    facebook:  { icon: brandIcons.facebook,  label: 'Facebook' },
    tiktok:    { icon: brandIcons.tiktok,    label: 'TikTok' },
    website:   { icon: brandIcons.website,   label: 'Sitio web' }
}

define('GoldHero', ({ business }) => {
    const { name, category, location, logo, image, whatsapp, social = {}, video, catalog } = business

    const socialBtns = Object.entries(SOCIAL_ICONS)
        .filter(([key]) => social[key])
        .map(([key, { icon, label }]) =>
            h('a', {
                href:      social[key],
                target:    '_blank',
                rel:       'noopener',
                className: 'gold-hero__social-btn',
                title:     label,
                'aria-label': label,
                innerHTML: icon
            })
        )

    const identity = h('div', { className: 'gold-hero__identity' },
        logo
            ? h('div', { className: 'gold-hero__logo-wrap' },
                h('img', { src: logo, alt: name, className: 'gold-hero__logo' })
            )
            : null,
        h('h1', { className: 'gold-hero__name' }, name),
        h('p', { className: 'gold-hero__meta', innerHTML: `${category} · ${uiIcons.pin} ${location}` }),
        socialBtns.length
            ? h('div', { className: 'gold-hero__socials' }, ...socialBtns)
            : null,
        h('a', {
            href:      waLink(whatsapp),
            target:    '_blank',
            rel:       'noopener',
            className: 'gold-hero__whatsapp',
            innerHTML: uiIcons.whatsapp + ' Contactar por WhatsApp'
        })
    )

    const videoWrap = h('div', { className: 'gold-hero__video-wrap' },
        video
            ? h('div', { className: 'gold-hero__video-thumb' },
                h('iframe', {
                    src:             youtubeEmbed(video),
                    className:       'gold-hero__iframe',
                    frameborder:     '0',
                    allow:           'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture',
                    allowfullscreen: true,
                    title:           'Video promocional'
                }),
                h('div', { className: 'gold-hero__video-label', innerHTML: uiIcons.play + ' Video promocional 30s' })
            )
            : null,
        catalog
            ? h('a', {
                href:      catalog.url,
                target:    '_blank',
                rel:       'noopener',
                className: 'gold-hero__catalog-btn',
                innerHTML: uiIcons.clipboard + ' Ver catálogo'
            })
            : null
    )

    const bgImg = image
        ? h('div', { className: 'gold-hero__bg' },
            h('img', { src: image, alt: '' })
        )
        : h('div', { className: 'gold-hero__bg', style: 'background: linear-gradient(135deg, #1a1a1a, #333)' })

    return h('div', { className: 'gold-hero' },
        bgImg,
        h('div', { className: 'gold-hero__overlay' }),
        h('div', { className: 'gold-hero__inner' },
            h('div', { className: 'gold-hero__badges' },
                h('span', { className: 'gold-hero__badge gold-hero__badge--gold', innerHTML: uiIcons.star + ' PLAN ORO' }),
                h('span', { className: 'gold-hero__badge gold-hero__badge--cat' }, category)
            ),
            h('div', { className: 'gold-hero__grid' },
                identity,
                videoWrap
            )
        )
    )
})
